import { withAuthenticationRequired, WithAuthenticationRequiredOptions } from "@auth0/auth0-react";
import { useMemo } from "react";

/**
 * Computes the current URL path including search and hash so it can be used as
 * Auth0's `returnTo` value. The Auth0 SDK default uses only `window.location.pathname`,
 * which silently drops query params and fragments across the login round-trip
 * (e.g. a reload of `/projects/123/testcases?modal=script-details&testCaseId=xyz` would
 * come back as `/projects/123/testcases`).
 */
const getCurrentReturnToUrl = (): string => {
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
};

const ProtectedRoute = ({
  component,
  args,
}: {
  component: React.ComponentType<object>;
  args?: WithAuthenticationRequiredOptions;
}) => {
  const Component = useMemo(() => {
    const mergedArgs: WithAuthenticationRequiredOptions = {
      returnTo: getCurrentReturnToUrl,
      ...args,
    };
    return withAuthenticationRequired(component, mergedArgs);
  }, [component, args]);
  return <Component />;
};

export default ProtectedRoute;
